
import { defineComponent, PropType, provide } from 'vue';
import { useVModel } from 'vue-composable';
import { useStore } from '@/store';
import { User } from '@/types/app';
import { InjectionKeys } from '@/constants';
import AppModal from '@/components/modal/base/AppModal.vue';
import { useFirebaseCloudFunctions } from '@/services';

export default defineComponent({
  name: 'UserDeleteFormModal',
  emits: ['update:openState'],
  components: {
    AppModal
  },
  props: {
    openState: {
      type: Boolean,
      required: true
    },
    user: {
      type: Object as PropType<User>
    }
  },
  setup(props) {
    const isOpen = useVModel(props, 'openState');
    const { removeGroup } = useFirebaseCloudFunctions();
    const store = useStore();

    const submit = async () => {
      if (props.user) {
        try {
          await removeGroup(props.user.email, props.user.name);

          await store.dispatch.users.delete(props.user);
        } catch (error) {
          console.error('Error during removal or deletion:', error);
        }
      }
    };

    provide(InjectionKeys.FormSubmit, submit);

    return {
      isOpen
    };
  }
});
